import { useMutation } from 'react-query';
import { message } from 'antd';
import request from '../../helpers/request';

const errorMessage = 'При удалении вложения произошла ошибка';

const mutationFn = ({ addressId, commentId, attachId }) => {
  return request.delete(
    `HousingStock/address/${addressId}/comment_v2/attachment?commentId=${commentId}&attachId=${attachId}`,
    undefined,
    errorMessage,
    'Error'
  );
};

const useDeleteFlatCommentAttachment = (options) => {
  return useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data === 'Error') {
        return;
      }

      if (data.success === false) {
        message.error(data.message || errorMessage);
        return;
      }

      if (typeof options?.onSuccess === 'function') {
        options.onSuccess(data, variables);
      }
    },
  });
};

export default useDeleteFlatCommentAttachment;
